import React           from 'react';

import styles          from './LegalFooter.module.scss';

import { WWW_URLS }    from '../../../backendServices/urls';
import { openCookiePreferences } from '../../../utils/cookieConsent';
import { appVersion , buildDate } from '../../../config/build_infos';

/**
 * Pied de page de la régie : les mêmes liens légaux que le pied de page du portail web
 * (portal/src/components/LegalPage.tsx › LegalFooter), sur une seule ligne discrète séparée par
 * des points médians. Les pages vivent sur le portail : les liens y mènent, dans un nouvel
 * onglet pour ne pas quitter la régie (un direct peut être en cours).
 *
 * ⚠️ Miroir de LEGAL_PAGES (portal/src/lib/legal.ts) : si une page légale est ajoutée ou
 * renommée là-bas, la mettre à jour ici.
 */
const LEGAL_LINKS = [
  { path: '/cgu',               label: "Conditions d'utilisation" },
  { path: '/regles-communaute', label: 'Règles de la communauté'  },
  { path: '/confidentialite',   label: 'Confidentialité et cookies' },
  { path: '/mentions-legales',  label: 'Mentions légales'         },
] as const;

const CONTACT_EMAIL = 'contact@kleon.tv';

export const LegalFooter: React.FC = () => (
  <footer className={styles.legalFooter}>
    <nav aria-label="Informations légales">
      {LEGAL_LINKS.map(link => (
        <a key={link.path} href={`${WWW_URLS.portal_front}${link.path}`} target="_blank" rel="noopener noreferrer">
          {link.label}
        </a>
      ))}
      <a href={`mailto:${CONTACT_EMAIL}`}>Contact</a>
      {/* Revenir sur son choix à tout moment (cf. utils/cookieConsent.ts). */}
      <a href="#cookies" onClick={e => { e.preventDefault(); openCookiePreferences(); }}>Gérer mes cookies</a>
    </nav>
    {/* Version et date du build en cours : de quoi dire, en cas de souci, quelle version tourne. */}
    <div className={styles.build}>Version {appVersion} · build du {buildDate}</div>
  </footer>
);

export default LegalFooter;
